import css from 'styled-jsx/css';
import { colors, icons } from '../../../config/styles';
import { svgToDataUri } from '../../../utils/styles/svgMixins';

const iconSize = `
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const DeliveryMethodSelectorStyles = css`
  .selectorWrapper {
    display: flex;
    justify-content: space-around;
    background: #f1f1f1;
    border-radius: 24px;
    padding: 4px;
    margin-bottom: 17px;
    width: 344px;
    @mixin mobileToTablet {
      width: 100%;
      height: 36px;
    }
  }
  .map-view {
    @mixin mobileToTablet {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
  }

  .option {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #333;
    font-style: normal;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .option:hover {
    background: #e0e0e0;
  }

  .option .deliveryAvailable {
    ${iconSize}
    background-image: url('${svgToDataUri(icons.homeDeliveryMint)}');
  }

  .option .pickupInStoreAvailable {
    ${iconSize}
    background-image: url('${svgToDataUri(icons.pickUpInStoreMint)}');
  }

  .option .see-stores {
    ${iconSize}
    background-image: url('${svgToDataUri(icons.stockInStoreMint)}');
  }

  .option.selected {
    background: ${colors.gray.shade64};
    color: #fefeff;
    font-weight: 700;
  }

  .option.selected .deliveryAvailable {
    background-image: url('${svgToDataUri(icons.homeDeliveryWhite)}');
  }

  .option.selected .pickupInStoreAvailable {
    background-image: url('${svgToDataUri(icons.pickUpInStoreWhite)}');
  }

  .option.selected .see-stores {
    background-image: url('${svgToDataUri(icons.stockInStoreWhite)}');
  }

  .icon {
    font-size: 18px;
  }
`;

export { DeliveryMethodSelectorStyles };
